export default __webpack_public_path__ + "static/media/kitchen5-beforeD-768w.e61066ca.avif";